import { useQuery } from "@tanstack/react-query";

import { supabase } from "../lib/index.js";
import { PreviewFile } from "./index.js";

export const PreviewSupabase = ({ fileUrl }: { fileUrl: string }) => {
  const { data } = useQuery({
    queryKey: ["PreviewSupabase", fileUrl],
    queryFn: () =>
      supabase.storage
        .from("files")
        .download(fileUrl.replace("files/", ""))
        .then((response) => {
          if (!response.data) {
            alert(JSON.stringify(response.error));
            throw response.error;
          }
          const filename = fileUrl.split("/").pop() || "fileName";
          return new File([response.data], filename, {
            type: response.data.type || "application/octet-stream",
          });
        }),
    staleTime: 0,
  });
  return data ? <PreviewFile file={data} /> : null;
};
